import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import fromPairs from 'lodash/fromPairs';
import { Motion } from 'react-motion';
import { springify } from '../../lib/Motion';
import { H5, L2, P1 } from '../Typography';
import Style from '../Style';

const TRANITION_DELAY = 10 * 1000;

class SignupScroller extends React.PureComponent {
  static propTypes = {};
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      activeSlide: 0,
    };
    this.nextTimeout = undefined;
  }

  componentDidMount() {
    this.autoNextSlide(TRANITION_DELAY);
  }

  componentWillUnmount() {
    clearTimeout(this.nextTimeout);
  }

  setActiveSlide = index => {
    this.setState({ activeSlide: index % MESSAGES.length });
    this.autoNextSlide(TRANITION_DELAY);
  };

  autoNextSlide = delay => {
    clearTimeout(this.nextTimeout);
    this.nextTimeout = setTimeout(
      () => this.setActiveSlide(this.state.activeSlide + 1),
      delay,
    );
  };

  render() {
    const animatedDefault = fromPairs(
      MESSAGES.map((_, index) => [`opacity_${index}`, 0]),
    );
    const animatedCurrent = {
      ...animatedDefault,
    };
    animatedCurrent[`opacity_${this.state.activeSlide}`] = 1;

    const indicatorRatio = 3;
    const indicatorGrid =
      100 / (MESSAGES.length * indicatorRatio + MESSAGES.length - 1);
    const indicatorWidth = 3 * indicatorGrid;

    return (
      <Motion defaultStyle={animatedDefault} style={springify(animatedCurrent)}>
        {tweens => (
          <div>
            <L2>TOP 3 REASONS TO JOIN STORYTAPE</L2>
            <div>
              {MESSAGES.map((item, index) => (
                <div
                  key={item.headline}
                  style={{ opacity: tweens[`opacity_${index}`] }}
                >
                  <H5>{item.headline}</H5>
                  <P1>{item.statement}</P1>
                </div>
              ))}
            </div>
            <div>
              {MESSAGES.map((item, index) => {
                const color = Color(Style.Colors.shadow5).mix(
                  Color(Style.Colors.white),
                  tweens[`opacity_${index}`],
                );
                const opacity = tweens[`opacity_${index}`] * 0.25 + 0.75;
                return (
                  <div
                    key={item.headline}
                    style={{
                      opacity,
                      backgroundColor: color,
                      height: '3px',
                      width: `${indicatorWidth}%`,
                      flexBasis: `${indicatorWidth}%`,
                      cursor: 'pointer',
                    }}
                    onClick={() => this.setActiveSlide(index)}
                  />
                );
              })}
            </div>
          </div>
        )}
      </Motion>
    );
  }
}

export default SignupScroller;

const MESSAGES = [
  {
    headline: '$$$$$$$',
    statement: 'Entire library subscription instead of crazy per clip prices',
  },
  {
    headline: 'Scenes, not just clips.',
    statement:
      'Instead of stand-alone clips, Storytape footage is grouped together in scenes to help you tell a story. And, clips average 20 seconds in length.',
  },
  {
    headline: '4K Baby!',
    statement: 'So... many... pixels...',
  },
];



// WEBPACK FOOTER //
// ./src/components/SignupScroller/SignupScroller.js